
import { PARTNERS_AND_AFFILIATES_ENDPOINTS, PROJECT_ENDPOINTS } from '../config/apiEndpoints';
import axios from 'axios';
import useAuth from './useAuth';
import { IProject } from '../data_models/project';
import { AffiliatePartner } from '../data_models/affiliatePartner';


function usePartnersAndAffiliates() {

    const { authToken } = useAuth();

    const fetchPartnersAndAffiliates = async (page: number, limit: number): Promise<Partial<AffiliatePartner>> => {
        try {
            const response = await axios.get(`${PARTNERS_AND_AFFILIATES_ENDPOINTS.GET_PARTNERS_AND_AFFILIATES}/`, {
                headers: {
                    Authorization: `${authToken}`,
                },
                params: {
                    page: page,
                    limit: limit
                },
            });
            return response.data;
        } catch (error: any) {
            // Check if the error has a response and a data property
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error); // Access the error message
            } else {
                throw new Error('An unexpected error occurred');
            }
        }
    }

    return {
        fetchPartnersAndAffiliates,

    };
}

export default usePartnersAndAffiliates;
